import { ConfigProvider, theme } from 'antd';
import type { ThemeConfig } from 'antd';

export const colors = {
  // Semantic status colors
  success: '#52c41a',
  error: '#ff4d4f',
  warning: '#faad14',
  info: '#1890ff',

  // Text
  textPrimary: '#000',
  textSecondary: '#8c8c8c',
  textTertiary: '#999',
  textMuted: '#666',

  // Backgrounds
  bgBase: '#f5f5f5',
  bgContainer: '#fff',
  bgElevated: '#fafafa',

  // Borders
  border: '#d9d9d9',
  borderLight: '#f0f0f0',

  // Sidebar
  sidebarBg: '#001529',

  // Highlights
  highlightBg: '#e6f7ff',

  // Specific status shades (for numbers, inventory)
  positiveNumber: '#389e0d',
  negativeNumber: '#cf1322',
} as const;

export const getAntdConfig = (isDark: boolean): ThemeConfig => ({
  algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
  token: {
    colorPrimary: colors.info,
    colorSuccess: colors.success,
    colorError: colors.error,
    colorWarning: colors.warning,
    borderRadius: 6,
    colorBgBase: isDark ? undefined : colors.bgBase,
  },
});

export { ConfigProvider };
